import React from 'react';
import PropTypes from 'prop-types';
import { UserTravelRoutes } from 'views/Users/Routes';
import { DatePicker, Form, Input } from 'antd';
import { FormWrapper } from 'components/Page';

const FormItem = Form.Item;

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const {
    passport_number, passport_expiry, passport_issue_location, home_city, home_country
  } = dataSource;

  return {
    passport_number: Form.createFormField({ value: passport_number }),
    passport_expiry: Form.createFormField({ value: passport_expiry }),
    passport_issue_location: Form.createFormField({ value: passport_issue_location }),
    home_city: Form.createFormField({ value: home_city }),
    home_country: Form.createFormField({ value: home_country })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, dataSource, inputFormItemLayout, form
}) => {
  // deconstruct dataSource and form
  const { getFieldDecorator } = form;
  const {
    user, passport_number, passport_expiry, passport_issue_location, home_city, home_country
  } = dataSource;
  const readonly = !canAdmin;
  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Passport No.">
        {getFieldDecorator('passport_number', {
          initialValue: passport_number
        })(<Input disabled={readonly} />)}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Passport Expiry">
        {getFieldDecorator('passport_expiry', {
          initialValue: passport_expiry
        })(<DatePicker disabled={readonly} format="DD-MM-YYYY" />)}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Passport Issue Location">
        {getFieldDecorator('passport_issue_location', {
          initialValue: passport_issue_location
        })(<Input disabled={readonly} />)}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Home Port City">
        {getFieldDecorator('home_city', {
          initialValue: home_city
        })(<Input disabled={readonly} />)}
      </FormItem>
      <FormItem {...inputFormItemLayout} label="Home Port Country">
        {getFieldDecorator('home_country', {
          initialValue: home_country
        })(<Input disabled={readonly} />)}
      </FormItem>
      <br />
      <FormItem {...inputFormItemLayout} label="Approved Routes">
        <UserTravelRoutes objectId={user} readonly={readonly} />
      </FormItem>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  checkboxFormItemLayout: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func,
  onRouteChange: PropTypes.func
};

FormInput.defaultProps = {
  canAdmin: false,
  dataSource: {},
  form: {},
  checkboxFormItemLayout: {},
  inputFormItemLayout: {},
  onFieldsChange() {
  },
  onValuesChange() {
  },
  onRouteChange() {
  }
};

const TravelInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(FormInput));

export default TravelInput;
